import styled from "styled-components";

export const OuterWrapper = styled.div`
    flex: 1 1 auto;
    min-height: 4rem;
    max-height: 15rem;
    width: 100%;
    flex-flow: column nowrap;
`;
